import { FormattedAlliedList } from '@/types'

export function alliedListFactory(res): FormattedAlliedList {
  return res
}
